export default __webpack_public_path__ + "static/media/cover_20230814.330ff428.jpg";